import React, { memo } from 'react';
import { InputValues } from '../advanceSearch/InterfaceTypes';
import { useFilterSettings } from '../hooks/advanced-search';
import dayjs from 'dayjs';

export const ChipLabel = memo((props: { inputValues: InputValues }) => {
  const filterSettings = useFilterSettings();
  let optionLabel;
  for (const f of filterSettings) {
    if (optionLabel) {
      break;
    }
    optionLabel = f.filterOptions.find(
      (o) => o.value === props.inputValues.filterOption
    )?.label;
  }

  let operatorLabel;
  for (const f of filterSettings) {
    if (operatorLabel) {
      break;
    }
    operatorLabel = f.operators
      .find((o) => o.value === props.inputValues.operator)
      ?.label.toLowerCase();
  }

  switch (props.inputValues.operator) {
    case 'is':
      return (
        <>
          {`${optionLabel}`} <strong>{operatorLabel}</strong>{' '}
          {`${dayjs(props.inputValues.value).format('YYYY-MM-DD')}`}
        </>
      );
    case 'range':
      return (
        <>
          {`${optionLabel}`} <strong>{operatorLabel}</strong>{' '}
          {`${dayjs(props.inputValues.value.starts).format(
            'YYYY-MM-DD'
          )} to ${dayjs(props.inputValues.value.ends).format('YYYY-MM-DD')}`}
        </>
      );
    default:
      return (
        <>
          {`${optionLabel}`} <strong>{operatorLabel}</strong>{' '}
          {`${props.inputValues.value}`}
        </>
      );
  }
});
